import { lazy, Suspense, useEffect } from "react";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import { clientRoutes } from "./utils/routes";
import { ToastContainer } from "react-toastify";
import MobileVerification from "./login/MobileVerification";
import "./App.css";
import "./fonts/fonts.css";
import "react-toastify/dist/ReactToastify.css";
import "./styles/colors.scss";
import "./styles/classes.scss";
import "./styles/animations.scss";
import "./styles/styles.scss";
import { PrivateRoute, AuthProvider } from "./Verification";
import ErrorBoundary from "./ErrorBoundary";
import LogOut from "./login/Logout";
import NewDeviceVerification from "./login/NewDeviceLogin";
import SetUpPage from "./login/SetupPage";
import Skeleton from "@mui/material/Skeleton";
import { LayoutContentProvider } from "./login/layout/layoutContentContext";

const Login = lazy(() => import("./login/Login"));

const AppLayout = () => {
  return (
    <LayoutContentProvider>
      <Suspense
      // fallback={
      //   <div style={{ padding: 16 }}>
      //     <Skeleton variant="rectangular" width="100%" height={100} />
      //     <Skeleton variant="text" />
      //     <Skeleton variant="text" />
      //   </div>
      // }
      >
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </Suspense>
      <ToastContainer />
    </LayoutContentProvider>
  );
};

// Define routes using createBrowserRouter
const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        element: <PrivateRoute />,
        children: [
          {
            path: clientRoutes.mobileVerification,
            element: <MobileVerification />,
          },
          {
            path: clientRoutes.newDeviceMobileVerification,
            element: <NewDeviceVerification />,
          },
        ],
      },

      {
        path: clientRoutes.login,
        element: <Login />,
      },
      {
        path: clientRoutes.logout,
        element: <LogOut />,
      },
    ],
  },
]);

const App = () => {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "dark");
  }, []);

  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
};

export default App;
